import React, { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SystemCompatibilityComponent from "../SystemCompatibilityComponent.tsx";

export function WithSystemCompatibility({ exam, disabled, handleStartExam }) {
  const [isCheckPassed, setIsCheckPassed] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const state = exam?.btnState;
  const proctoringEnabled = Boolean(exam?.proctoringEnabled);

  // Check if System Compatibility is required before starting
  const needsSystemCheck = proctoringEnabled && state === "START" && !disabled && !isCheckPassed;

  const handleClick = () => {
    if (needsSystemCheck) {
      setIsModalOpen(true);
    } else {
      handleStartExam(exam);
    }
  };

  const handleSuccess = () => {
    setIsCheckPassed(true);
    setIsModalOpen(false);
  };

  return (
    <>
      <Button
        variant="contained"
        color={needsSystemCheck ? "secondary" : "primary"}
        onClick={handleClick}
        disabled={disabled}
      >
        {needsSystemCheck ? "System Compatibility" : "START EXAM"}
      </Button>

      {isModalOpen && (
        <Dialog
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          maxWidth="md"
          fullWidth
        >
          <Box sx={{ display: "flex", justifyContent: "flex-end", p: 1 }}>
            <IconButton onClick={() => setIsModalOpen(false)} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Box>
          <DialogContent sx={{ pt: 0 }}>
            <SystemCompatibilityComponent
              proctoringType={exam?.proctoringType || "lite"}
              locationType={exam?.isSafeExamBrowser ? "off" : "on"}
              onSuccess={handleSuccess}
            />
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}

export default WithSystemCompatibility;